<div [id]="id" *ngIf="isVisible" class="mt-1 banner-overlay banner-yellow flex flex-row justify-between gap-2">

    <div class="flex flex-row items-center gap-2">
        <span *ngIf="bannerIcon" class="material-symbols-rounded icon-20">{{ bannerIcon }}</span>
        <span class="body-small-regular">{{ message }}</span>
    </div>

    <div class="flex flex-row items-center gap-2 border-l border-black">

        <button class="pl-2 material-symbols-rounded icon-24" (click)="closeBanner()">{{ materialSymbols.close }}</button>
    </div>
</div>
